export const temporaryRedirects = [
  {originalPath:"/es/lodges/patagonia", newPath:"/patagonia"},
  {originalPath:"/fr/lodges/patagonia", newPath:"/patagonia"},
  {originalPath:"/pt/lodges/patagonia", newPath:"/patagonia"},
  {originalPath:"/en/lodges/patagonia", newPath:"/patagonia"},
  {originalPath:"/de/lodges/patagonia", newPath:"/patagonia"},
  {originalPath:"/lodges/patagonia", newPath:"/patagonia"},
  {originalPath:"/es/lodges/atacama", newPath:"/atacama"},
  {originalPath:"/fr/lodges/atacama", newPath:"/atacama"},
  {originalPath:"/pt/lodges/atacama", newPath:"/atacama"},
  {originalPath:"/en/lodges/atacama", newPath:"/atacama"},
  {originalPath:"/de/lodges/atacama", newPath:"/atacama"},
  {originalPath:"/lodges/atacama", newPath:"/atacama"},
  {originalPath:"/es/lodges/iguazu", newPath:"/iguazu"},
  {originalPath:"/fr/lodges/iguazu", newPath:"/iguazu"},
  {originalPath:"/pt/lodges/iguazu", newPath:"/iguazu"},
  {originalPath:"/en/lodges/iguazu", newPath:"/iguazu"},
  {originalPath:"/de/lodges/iguazu", newPath:"/iguazu"},
  {originalPath:"/lodges/iguazu", newPath:"/iguazu"},
  {originalPath:"/blog/a-south-america-treasure-awasi-iguazu-in-forbes", newPath:"/blog"},
  {originalPath:"/blog/a-new-painting-for-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/a-recipe-from-juan-pablo-mardones-head-chef-awasi-atacama", newPath:"/blog"},
  {originalPath:"/blog/a-recipe-of-awasi-patagonia-chef-federico-ziegler", newPath:"/blog"},
  {originalPath:"/blog/a-recipe-from-awasi-atacama-scallop-carpaccio", newPath:"/blog"},
  {originalPath:"/blog/an-interactive-guide-to-excursions-at-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/a-team-of-many-talents-jimena-choque-volunteer-firefighter", newPath:"/blog"},
  {originalPath:"/blog/a-view-you-will-never-forget-patagonia", newPath:"/blog"},
  {originalPath:"/blog/an-archaeological-excavation-in-iguazus-atlantic-rainforest", newPath:"/blog"},
  {originalPath:"/blog/an-interactive-guide-to-excursions-at-awasi-atacama", newPath:"/blog"},
  {originalPath:"/blog/artist-in-residence-photographer-ingrid-weyland-visits-iguazu", newPath:"/blog"},
  {originalPath:"/blog/atacama-desert-named-astronomy-capital-of-the-world-by-travel-leisure", newPath:"/blog"},
  {originalPath:"/blog/ancient-eats-in-patagonia", newPath:"/blog"},
  {originalPath:"/blog/atacama-legends-inca-gold", newPath:"/blog"},
  {originalPath:"/blog/architecture-in-torres-del-paine-chile", newPath:"/blog"},
  {originalPath:"/blog/artists-inspired-by-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/atacama-patagonia-iguazu-flying-start", newPath:"/blog"},
  {originalPath:"/blog/awasi-artist-immersion-iliana-diaz-lopez", newPath:"/blog"},
  {originalPath:"/blog/awasi-atacama-in-your-words-2", newPath:"/blog"},
  {originalPath:"/blog/awasi-artist-immersion-ingrid-weyland", newPath:"/blog"},
  {originalPath:"/blog/awasi-atacama-appears-in-the-conde-nast-traveller-gold-list-2019", newPath:"/blog"},
  {originalPath:"/blog/awasi-atacama-in-family-traveller-magazine", newPath:"/blog"},
  {originalPath:"/blog/awasi-atacama-in-national-geographic-traveller", newPath:"/blog"},
  {originalPath:"/blog/awasi-atacama-in-your-words", newPath:"/blog"},
  {originalPath:"/blog/awasi-atacama-tailor-made-tipple", newPath:"/blog"},
  {originalPath:"/blog/awasi-atacama-through-the-lens", newPath:"/blog"},
  {originalPath:"/blog/awasi-atacama-welcomes-a-new-resident-manager", newPath:"/blog"},
  {originalPath:"/blog/awasi-chefs-homage-to-patagonian-cuisine", newPath:"/blog"},
  {originalPath:"/blog/awasi-experience-patagonia-atacama", newPath:"/blog"},
  {originalPath:"/blog/awasi-guests-enjoy-iguazu-falls-before-the-crowds", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-conde-nast-traveller-hot-list-2018", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-among-five-lodges-for-total-forest-immersion", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-among-forbes-magazines-10-best-hotels-resorts-of-the-year-2019", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-conde-nast-travelers-hotlist2019", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-in-the-financial-times", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-guide-biodiversity-expert", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-pioneers-the-use-of-the-jejya-fruit", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-in-national-geographic-traveller-magazine", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazus-jerusalemadancechallenge", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-in-the-new-york-post", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-in-the-travel-leisure-it-list-2019", newPath:"/blog"},
  {originalPath:"/blog/awasi-patagonia-among-the-worlds-top-10-hotels-according-to-the-telegraph", newPath:"/blog"},
  {originalPath:"/blog/awasi-patagonia-an-artists-refuge", newPath:"/blog"},
  {originalPath:"/blog/awasi-patagonia-in-the-telegraph-newspaper", newPath:"/blog"},
  {originalPath:"/blog/awasi-patagonia-in-your-words", newPath:"/blog"},
  {originalPath:"/blog/awasi-patagonia-named-among-the-worlds-10-best-hotels", newPath:"/blog"},
  {originalPath:"/blog/awasi-iguazu-in-harpers-bazaar-brazil", newPath:"/blog"},
  {originalPath:"/blog/awasi-puma-video", newPath:"/blog"},
  {originalPath:"/blog/awasi-puma-film-in-new-york-film-festival", newPath:"/blog"},
  {originalPath:"/blog/awasi-talks-biodiversity-in-the-atlantic-rainforest", newPath:"/blog"},
  {originalPath:"/blog/awasipatagoniaheadchef", newPath:"/blog"},
  {originalPath:"/blog/bedtime-stories-the-alicanto-bird", newPath:"/blog"},
  {originalPath:"/blog/bedtime-stories-the-stars", newPath:"/blog"},
  {originalPath:"/blog/bedtime-stories-the-treasure-of-mount-quimal-and-other-stories", newPath:"/blog"},
  {originalPath:"/blog/awasiguazuvideo", newPath:"/blog"},
  {originalPath:"/blog/best-hotels-in-south-america-per-fodors", newPath:"/blog"},
  {originalPath:"/blog/born-to-fly-releasing-rescued-birds-back-into-the-wild", newPath:"/blog"},
  {originalPath:"/blog/birdwatcher-iguazu-film-nominated-film-festival", newPath:"/blog"},
  {originalPath:"/blog/chipa-recipe-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/category/iguazu", newPath:"/blog"},
  {originalPath:"/blog/category/patagonia", newPath:"/blog"},
  {originalPath:"/blog/chef-victor-vilugron-of-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/conde-nast-traveler-selects-the-best-hotels-surrounded-by-nature", newPath:"/blog"},
  {originalPath:"/blog/creating-delicious-journeys-by-relais-chateaux", newPath:"/blog"},
  {originalPath:"/blog/darwin-in-patagonia", newPath:"/blog"},
  {originalPath:"/blog/delivering-luxury-experiences-in-a-remote-hotel", newPath:"/blog"},
  {originalPath:"/blog/desert-chef-or-glacier-chef", newPath:"/blog"},
  {originalPath:"/blog/ever-tried-yerba-mate", newPath:"/blog"},
  {originalPath:"/blog/dry-or-wet-the-ultimate-packing-list-for-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/family-day-at-awasi-atacama", newPath:"/blog"},
  {originalPath:"/blog/combine-awasi-atacama-and-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/family-day-at-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/from-jungle-to-table-palm-heart-pulp-in-iguazu", newPath:"/blog"},
  {originalPath:"/blog/food-for-change-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/food-in-iguazu", newPath:"/blog"},
  {originalPath:"/blog/foodie-eating-at-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/hotels-with-the-dreamiest-outdoor-showers-by-travel-leisure", newPath:"/blog"},
  {originalPath:"/blog/geoffroys-cat-sighting-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/honeymoon-jewellery-designer-creates-collection-inspired-by-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/head-excursions-joins-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/have-you-visited-south-americas-golden-triangle-yet-2", newPath:"/blog"},
  {originalPath:"/blog/how-many-days-do-you-need-to-explore-the-atacama-desert", newPath:"/blog"},
  {originalPath:"/blog/i-have-reviewed-hundreds-of-hotels-this-is-what-makes-a-perfect-10-awasi-in-the-press", newPath:"/blog"},
  {originalPath:"/blog/how-many-days-do-you-need-to-explore-the-iguazu-falls-argentina", newPath:"/blog"},
  {originalPath:"/blog/iguazu-new-natural-spa", newPath:"/blog"},
  {originalPath:"/blog/how-many-days-do-you-need-to-explore-torres-del-paine-chile", newPath:"/blog"},
  {originalPath:"/blog/iguazus-iconic-devils-throat-reopens-after-record-breaking-water-levels", newPath:"/blog"},
  {originalPath:"/blog/international-forest-day-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/listen-sounds-jungle-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/interview-with-jimmy-mccormick-awasi-iguazu-guide", newPath:"/blog"},
  {originalPath:"/blog/jineteadas-a-taste-of-gaucho-culture", newPath:"/blog"},
  {originalPath:"/blog/love-in-the-heart-of-nature-with-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/meet-coti-mainero-guide-of-the-year", newPath:"/blog"},
  {originalPath:"/videos/awasi-iguazu-relais-chateaux", newPath:"/gallery"},
  {originalPath:"/videos/awasi-iguazu-relais-chateaux", newPath:"/gallery"},
  {originalPath:"/blog/wp-content/uploads/2025/02/Awasi-Iguazu-Factsheet-ENG.pd", newPath:"/blog"},
  {originalPath:"/blog/yerba-mate-the-rudiments-and-beyond", newPath:"/blog"},
  {originalPath:"/blog/wp-content/uploads/2025/02/Awasi-Atacama-Factsheet-ENG.pd", newPath:"/blog"},
  {originalPath:"/blog/worlds-greatest-places-2018-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/winter-in-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/winter-wonderland-at-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/what-to-wear-packing-list-for-awasi-atacama", newPath:"/blog"},
  {originalPath:"/blog/why-travel-to-chiles-atacama-desert-between-may-and-october", newPath:"/blog"},
  {originalPath:"/blog/why-solitude-is-now-the-most-coveted-commodity-in-travel-awasi-in-vogue", newPath:"/blog"},
  {originalPath:"/blog/welcoming-chef-sebastian-prieto-to-awasi-atacama", newPath:"/blog"},
  {originalPath:"/blog/visit-awasi-iguazu-as-part-of-an-unforgettable-two-week-trip-to-argentina", newPath:"/blog"},
  {originalPath:"/blog/what-happens-in-iguazu-between-may-and-october", newPath:"/blog"},
  {originalPath:"/blog/wellness-at-the-awasi-lodges", newPath:"/blog"},
  {originalPath:"/blog/vogue-anticipated-hotel-openings-2017", newPath:"/blog"},
  {originalPath:"/blog/visit-awasi-atacama-and-awasi-iguazu-with-children", newPath:"/blog"},
  {originalPath:"/blog/video-a-family-trip-to-atacama", newPath:"/blog"},
  {originalPath:"/blog/unveiling-iguazus-hidden-wildlife", newPath:"/blog"},
  {originalPath:"/blog/travel-with-a-clean-conscience-by-relais-chateaux", newPath:"/blog"},
  {originalPath:"/blog/travel-inspiration-combine-awasi-atacama-clos-apalta-residence", newPath:"/blog"},
  {originalPath:"/blog/torres-del-paine-named-in-worlds-greatest-places-2023-by-time-magazine", newPath:"/blog"},
  {originalPath:"/blog/through-the-keyhole-a-photographic-tour-of-awasi-atacama", newPath:"/blog"},
  {originalPath:"/blog/the-ultimate-adventure-in-chiles-atacama-desert-by-travel-leisure", newPath:"/blog"},
  {originalPath:"/blog/the-tehuelches-indians-the-native-tribes-of-patagonia-southern-chile", newPath:"/blog"},
  {originalPath:"/blog/the-pioneers-of-southern-patagonia", newPath:"/blog"},
  {originalPath:"/blog/the-plant-of-the-gods-that-changed-history", newPath:"/blog"},
  {originalPath:"/blog/the-jaguars-of-the-iguazu-jungle", newPath:"/blog"},
  {originalPath:"/blog/the-best-honeymoon-destination", newPath:"/blog"},
  {originalPath:"/blog/the-awasi-academy-2019", newPath:"/blog"},
  {originalPath:"/blog/the-water-of-life-did-you-know-we-filter-our-own-water", newPath:"/blog"},
  {originalPath:"/blog/tag/where-to-travel-in-chile", newPath:"/blog"},
  {originalPath:"/blog/that-floating-feeling-at-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/taking-the-plunge-at-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/tag/selva-atlantica", newPath:"/blog"},
  {originalPath:"/blog/tag/tapir", newPath:"/blog"},
  {originalPath:"/blog/tag/san-pedro-de-atacama", newPath:"/blog"},
  {originalPath:"/blog/tag/stargazing", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux/page/9", newPath:"/blog"},
  {originalPath:"/blog/talent-at-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/tag/safari-patagonia", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux/page/3", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux/page/13", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux/page/11", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux/page/10", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux-hotel-chile/page/3", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux/page/8", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux-hotel-chile/page/2", newPath:"/blog"},
  {originalPath:"/blog/the-driest-place-on-earth", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-and-chateaux", newPath:"/blog"},
  {originalPath:"/blog/tag/puma-tracking/page/2", newPath:"/blog"},
  {originalPath:"/blog/tag/patagonia", newPath:"/blog"},
  {originalPath:"/blog/tag/patagonia-luxury-hotel", newPath:"/blog"},
  {originalPath:"/blog/tag/patagonia-lodge", newPath:"/blog"},
  {originalPath:"/blog/tag/nature-reserva-patagonia", newPath:"/blog"},
  {originalPath:"/blog/tag/jerusalema-dance-challenge", newPath:"/blog"},
  {originalPath:"/blog/tag/maria-shollenbarger", newPath:"/blog"},
  {originalPath:"/blog/tag/relais-chateaux-hotel-chile", newPath:"/blog"},
  {originalPath:"/blog/tag/guarani-culture", newPath:"/blog"},
  {originalPath:"/blog/tag/iguazu-falls", newPath:"/blog"},
  {originalPath:"/blog/tag/foodies-argentina", newPath:"/blog"},
  {originalPath:"/blog/tag/chile-stargazing", newPath:"/blog"},
  {originalPath:"/blog/tag/chilean-patagonia", newPath:"/blog"},
  {originalPath:"/blog/tag/chile-hotel", newPath:"/blog"},
  {originalPath:"/blog/tag/htsi", newPath:"/blog"},
  {originalPath:"/blog/tag/chile-in-the-press", newPath:"/blog"},
  {originalPath:"/blog/tag/best-of-south-america/page/10", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotels-in-atacama", newPath:"/blog"},
  {originalPath:"/blog/tag/best-of-south-america", newPath:"/blog"},
  {originalPath:"/blog/tag/best-of-chile", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotel-south-america", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotel-in-chile/page/5", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotel-in-patagonia", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotel-iguazu", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotel-in-chile/page/2", newPath:"/blog"},
  {originalPath:"/blog/tag/foodies-chile/page/2", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotel-chile/page/6", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotel-chile", newPath:"/blog"},
  {originalPath:"/blog/tag/atacama-photo", newPath:"/blog"},
  {originalPath:"/blog/tag/best-hotel-in-south-america/page/2", newPath:"/blog"},
  {originalPath:"/blog/tag/atacama-luxury-hotel", newPath:"/blog"},
  {originalPath:"/blog/tag/atacama-desert", newPath:"/blog"},
  {originalPath:"/blog/tag/awasi-patagonia/page/2", newPath:"/blog"},
  {originalPath:"/blog/tag/atacama-hotel", newPath:"/blog"},
  {originalPath:"/blog/tag/atacama-desert-chile", newPath:"/blog"},
  {originalPath:"/blog/tag/argentina-sustainable-hotel", newPath:"/blog"},
  {originalPath:"/blog/tag/10-of-the-best-hotels", newPath:"/blog"},
  {originalPath:"/blog/swimming-baby-tapir-spotted-by-awasi-iguazu-guests", newPath:"/blog"},
  {originalPath:"/blog/stargazing-chile-atacama-desert", newPath:"/blog"},
  {originalPath:"/blog/supporting-the-conservation-of-capuchin-monkeys-at-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/stella-nanni-awasi", newPath:"/blog"},
  {originalPath:"/blog/southern-hemisphere-stonehenge-in-chile", newPath:"/blog"},
  {originalPath:"/blog/tag/awasi-hotels-chile", newPath:"/blog"},
  {originalPath:"/blog/safari-in-the-worlds-driest-desert", newPath:"/blog"},
  {originalPath:"/blog/size-and-layout-changes-at-awasi-atacama-relais-chateaux", newPath:"/blog"},
  {originalPath:"/blog/saving-lulu-the-tale-of-a-tapir", newPath:"/blog"},
  {originalPath:"/blog/rewilding-iguazu", newPath:"/blog"},
  {originalPath:"/blog/relais-chateaux-launches-new-travel-book", newPath:"/blog"},
  {originalPath:"/blog/relais-chateaux-and-slow-food-combine-forces-to-protect-biodiversity", newPath:"/blog"},
  {originalPath:"/blog/sierra-baguales-patagonias-hot-spot", newPath:"/blog"},
  {originalPath:"/blog/slow-food", newPath:"/blog"},
  {originalPath:"/blog/rain-or-shine-packing-list-for-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/puma-spotting-at-estancia-lazo-part-1", newPath:"/blog"},
  {originalPath:"/blog/pisco-sour-recipe-from-awasi-patagonia", newPath:"/blog"},
  {originalPath:"/blog/promotions", newPath:"/blog"},
  {originalPath:"/blog/promos/combine-atacama-patagonia-2", newPath:"/blog"},
  {originalPath:"/blog/president-macri-visits-awasi-iguazu-relais-chateaux", newPath:"/blog"},
  {originalPath:"/blog/our-great-national-parks-chilean-patagonia", newPath:"/blog"},
  {originalPath:"/blog/photographic-tour-of-patagonia", newPath:"/blog"},
  {originalPath:"/blog/penelope-chilvers-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/patagonia-features-in-the-bbcs-wilderness-with-explorer-simon-reeve", newPath:"/blog"},
  {originalPath:"/blog/noctourism-in-the-atacama-desert-forecast-for-2025", newPath:"/blog"},
  {originalPath:"/blog/new-season-new-flights", newPath:"/blog"},
  {originalPath:"/blog/new-time-lapse-videos-tracking-patagonias-pumas-using-hidden-cameras", newPath:"/blog"},
  {originalPath:"/blog/new-stargazing-experience-at-awasi-atacama", newPath:"/blog"},
  {originalPath:"/blog/new-spa-on-feet-at-awasi-iguazu-argentina", newPath:"/blog"},
  {originalPath:"/blog/new-private-activities-at-awasi-iguazu", newPath:"/blog"},
  {originalPath:"/blog/new-documentary-features-the-awasi-puma-foundation", newPath:"/blog"},
  {originalPath:"/blog/nature-art-mankind-at-awasi-iguazu-argentina", newPath:"/blog"},
  {originalPath:"/blog/modern-myth-from-the-atacama-desert", newPath:"/blog"},
  {originalPath:"/blog/memories-of-patagonia-guanacos-by-george-chaworth-musters", newPath:"/blog"},
  {originalPath:"/blog/national-potato-day-chile", newPath:"/blog"},
  {originalPath:"/blog/my-first-sighting-of-puma-in-the-wild-chris-moss-visits-awasi-patagonia-for-the-telegraph", newPath:"/blog"},
  {originalPath:"/blog/meet-pumas-awasi", newPath:"/blog"},
  {originalPath:"/santa-catarnia", newPath:"/santa-catarina"}
];